import React from "react";
import styled from "styled-components";
import defaultTheme from "../../../theme/defaultTheme";
import { KEYBOARD_KEY_CONSTANTS } from "../../../constants/global";
import { IconArrowRightCircleFill } from "@amzn/stencil-react-components/icons";

const ACTIVE_COLOR = defaultTheme.palette.darkBlue;
const INACTIVE_COLOR = defaultTheme.palette.brightGray;

const SendButton = styled.div`
  cursor: ${(props) => (props.isActive ? "pointer" : "default")};
`;

/**
 * Send message button for the Chat Composer.
 *
 * @param {Object} props
 * @param {boolean} props.isActive
 * @param {Function} props.sendMessage
 */
function SendMessageButton({ isActive, sendMessage }) {
  return (
    <SendButton
      isActive={isActive}
      onClick={sendMessage}
      data-testid="customer-chat-send-message-button"
      aria-label="Send Message"
      aria-disabled={!isActive}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        // if space or enter is pressed
        if (
          e.key === KEYBOARD_KEY_CONSTANTS.SPACE ||
          e.key === KEYBOARD_KEY_CONSTANTS.ENTER
        ) {
          sendMessage(e);
        }
      }}
    >
      <IconArrowRightCircleFill
        color={isActive ? ACTIVE_COLOR : INACTIVE_COLOR}
      />
    </SendButton>
  );
}

export default SendMessageButton;
